import { addDatapointConfig } from 'owa-analytics-actions';
import { OwaDate } from 'owa-datetime';
import { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import { action } from 'satcheljs';
import {
    CreateEventTarget,
    getTimePanelDndCustomData,
    timePanelDndOptions,
    CreateEventFromMailItemDropCustomData,
} from '../datapoints';

export const createEventFromMailItemDrop = action(
    'createEventFromMailItemDrop',
    (dragData: MailListRowDragData, dropTarget: CreateEventTarget, preFillStartTime?: OwaDate) =>
        addDatapointConfig(
            {
                name: 'timePanelActionCreateEventFromMailItemDrop',
                options: timePanelDndOptions,
                customData: getTimePanelDndCustomData<CreateEventFromMailItemDropCustomData>({
                    dropTarget: dropTarget,
                }),
            },
            {
                dragData,
                dropTarget,
                preFillStartTime,
            }
        )
);

// NOTE: Currently this action is forwarded in Time Panel to Todos as a stopgap
//       until Todo Panel is deprecated and `owa-todos` can be decomposed.
//       Datapoint is handled in `owa-todos` forwarding action.
export const createTaskFromMailItemDrop = action(
    'createTaskFromMailItemDrop',
    (dragData: MailListRowDragData, folderId: string) =>
        addDatapointConfig(
            {
                name: 'timePanelActionCreateTaskFromMailItemDrop',
                options: timePanelDndOptions,
            },
            {
                dragData,
                folderId,
            }
        )
);
